module.exports = __webpack_public_path__ + "static/media/Helicopter.88f5aba9.mp3";